<template>
  <div class="menu-item-r">
    <div class="v-company-manangement">
      <div class="v-nav-wrap flex-start align-center">
        <div>
          <el-button class="el-button--primary-empty" type="primary" size="small" @click="$router.push('/company-info')">{{$t('companyEditor')}}</el-button>
        </div>
      </div>
      <div class="v-module" v-if="detail.logoImage">
        <p class="v-module-title">Logo</p>
        <el-avatar :size="200" :fit="'contain'" class="no-border" :src="detail.logoImage" style="border-radius: 0"></el-avatar>
      </div>
      <div class="v-module" v-if="detail.advertsImage">
        <p class="v-module-title">{{$t('img')}}</p>
        <v-swiper :option="swiperOption"></v-swiper>
      </div>
      <div class="v-module" v-if="detail.advertsVideo">
        <p class="v-module-title">{{$t('video')}}</p>
        <v-swiper @callback="callback" :option="swiperOption2"></v-swiper>
        <v-video :isShow="isShowV" @callback="callback" :src='detail.advertsVideo'></v-video>
      </div>
      <div class="v-module font-size-16">
        <p class="v-module-title">{{$t('baseMess')}}</p>
        <template v-if='language == "zh"'>
          <div class="v-color"><span>{{$t('companyInfo.name')}}：</span><span>{{detail.name || '--'}}</span></div>
          <div class="v-color" v-if='detail.enName'><span>{{$t('companyInfo.enName')}}：</span><span>{{detail.enName}}</span></div>
        </template>
        <template v-if='language == "en" && detail.enName'>
          <div class="v-color"><span>{{$t('companyInfo.name')}}：</span><span>{{detail.enName || '--'}}</span></div>
        </template>
        <div class="v-color" v-if="detail.exhibitionFloor"><span>{{$t('companyInfo.exhibitionFloor')}}：</span><span>{{detail.exhibitionFloor}}</span></div>
        <div class="v-color" v-if="detail.exhibitionBoothPart"><span>{{$t('companyInfo.exhibitionBoothPart')}}：</span><span>{{detail.exhibitionBoothPart}}</span></div>
        <div class="v-color" v-if="detail.exhibitionBoothNumber"><span>{{$t('companyInfo.exhibitionBoothNumber')}}：</span><span>{{detail.exhibitionBoothNumber}}</span></div>
        <!-- <div class="v-color" v-if="detail.listed"><span>{{$t('companyInfo.listed')}}：</span><span>{{detail.listed ? $t('companyInfo.yes') : $t('companyInfo.no')}}</span></div> -->
        <div class="v-color" v-if="detail.brand"><span>{{$t('companyInfo.brand')}}：</span><span>{{detail.brand}}</span></div>
        <div class="flex-start font-size-14 v-company-mess margin-t-0">
          <div class="v-color" v-if="detail.countryName"><span>{{$t("companyInfo.country")}}：</span><span>{{detail.countryName}}</span></div>
          <div class="v-color" v-if="detail.provinceName"><span>{{$t('companyInfo.province')}}：</span><span>{{detail.provinceName}}</span></div>
          <div class="v-color" v-if="detail.cityName"><span>{{$t('companyInfo.city')}}：</span><span>{{detail.cityName}}</span></div>
        </div>
        <template v-if='language == "zh" && detail.address'>
          <div class="v-color"><span>{{$t("companyInfo.address")}}：</span><span>{{detail.address || '--'}}</span></div>
          <div class="v-color" v-if="detail.enAddress"><span>{{$t("companyInfo.enAddress")}}：</span><span>{{detail.enAddress}}</span></div>
        </template>
        <template v-if='language == "en" && detail.enAddress'>
          <div class="v-color"><span>{{$t("companyInfo.address")}}：</span> <span>{{detail.enAddress || '--'}}</span></div>
        </template>
        <div class="v-color" v-if="detail.telephone"><span>{{$t("companyInfo.telephone")}}：</span><span>{{detail.telephone}}</span></div>
        <div class="v-color" v-if="detail.email"><span>{{$t("companyInfo.email")}}：</span><span>{{detail.email}}</span></div>
        <div class="v-color" v-if="detail.webUrl"><span>{{$t("companyInfo.webUrl")}}：</span><span><a :href="detail.webUrl" target="view_window">{{$t('finds.enterDetail')}}</a></span></div>
        <div class="v-color" v-if="detail.url3d"><span>{{$t("companyInfo.url3d")}}：</span><span><a :href="detail.url3d" target="view_window">{{$t('finds.enterDetail')}}</a></span></div>
        <div class="v-color" v-if="detail.zipCode"><span>{{$t('companyInfo.zipCode')}}：</span><span>{{detail.zipCode}}</span></div>
        <div class="v-color" v-if="detail.linkName"><span>{{$t('companyInfo.linkName')}}：</span><span>{{detail.linkName}}</span></div>
        <div class="v-color" v-if="detail.linkMobile"><span>{{$t('companyInfo.linkMobile')}}：</span><span>{{detail.linkMobile}}</span></div>
        <div class="v-color" v-if="detail.linkEmail"><span>{{$t('companyInfo.linkEmail')}}：</span><span>{{detail.linkEmail}}</span></div>
        <div class="v-color" v-if="detail.linkName1"><span>{{$t('companyInfo.linkName1')}}：</span><span>{{detail.linkName1}}</span></div>
        <div class="v-color" v-if="detail.linkMobile1"><span>{{$t('companyInfo.linkMobile1')}}：</span><span>{{detail.linkMobile1}}</span></div>
        <div class="v-color" v-if="detail.linkEmail1"><span>{{$t('companyInfo.linkEmail1')}}：</span><span>{{detail.linkEmail1}}</span></div>
        <div class="flex-start font-size-14 v-company-mess">
          <div v-if="detail.attendTimes">{{$t('companyInfo.attendTimes')}} <span class="theme-icon-primary-color p-l-5">{{detail.attendTimes || '--'}}</span></div>
          <div v-if="detail.registeredCapital">{{$t('companyInfo.registeredCapital')}} <span class="theme-icon-primary-color p-l-5">{{detail.registeredCapital || '--'}}</span></div>
          <div v-if="detail.companyScale">{{$t('companyInfo.companyScale')}} <span class="theme-icon-primary-color p-l-5">{{detail.companyScale || '--'}}</span></div>
        </div>
      </div>
      <template v-if='language == "zh"'>
        <div class="v-color" v-if="detail.introduction"><span>{{$t('companyInfo.introduction')}}：</span></div>
        <div class="v-module v-intro" v-if="detail.introduction">
          <p class="p">{{detail.introduction}}</p>
        </div>
        <div class="v-color" v-if="detail.enIntroduction"><span>{{$t('companyInfo.enIntroduction')}}：</span></div>
        <div class="v-module v-intro" v-if="detail.enIntroduction">
          <p class="p">{{detail.enIntroduction}}</p>
        </div>
      </template>
      <template v-if='language == "en"'>
        <div class="v-color"><span>{{$t('companyInfo.introduction')}}：</span></div>
        <div class="v-module v-intro">
          <p class="p">{{detail.enIntroduction}}</p>
        </div>
      </template>
      
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getExhibitorBaseInfo } from '@/api/index'
import vVideo from '@/components/vVideo'
import vSwiper from '@/components/vSwiper'
import def from '@/assets/def.jpg'

export default {
  name: 'companyManagement',
  components: {
    vVideo,
    vSwiper
  },
  data() {
    return {
      def:def,
      swiperOption:{
        imgW:'360px',
        imgH:'200px',
        list: []
      },
      swiperOption2:{
        imgW:'360px',
        imgH:'200px',
        list: [],
        type: ['video']
      },
      isShowV: false,
      detail: {}
    }
  },
  computed: {
    ...mapGetters(['language', 'info']),
    noAdmin() {
      return !this.info || (this.info && !this.info.exhibitorEmployee) || (this.info && this.info.exhibitorEmployee && !this.info.exhibitorEmployee.admin)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if(vm.noAdmin) {
        vm.$router.replace('/')
      }
    })
  },
  mounted() {
    if(!this.noAdmin) {
      this.fetchInfo()
    }
  },
  methods: {
    fetchInfo () {
      const loading = this.$loading();
      getExhibitorBaseInfo({
        id: this.$store.getters.exhibitorId
      }).then(res => {
        return res.data
      }).then(res => {
        if(res.code === 1000 && res.data) {
          this.detail = res.data
          let advertsImage = res.data.advertsImage;
          advertsImage = advertsImage ? advertsImage.split(',') : ''
          this.swiperOption.list = advertsImage
          if(this.detail.advertsVideo) {
            if(res.data.advertsVideoImage == '') {
              this.swiperOption2.list['0'] = def
            } else {
              this.swiperOption2.list['0'] = res.data.advertsVideoImage
            }
          }
        }
      }).finally(() => {
        loading.close()
      })
    },
    callback(res) {
      if (res.type == 'video') {
        this.isShowV = false
      }else if(res.type=="swiper"){
        this.isShowV=true;
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-company-manangement{
  width:100%;
  padding: 0 15px 68px;
  max-width:$container-width;
  margin: 30px auto;
  background: $color-gray-fb;
  .v-color{
    color:$color-black-45 ;
    margin-bottom:8px;
  }
  .v-nav-wrap{
    .v-select{
      margin:0 23px 0 12px;
    }
  }
  .v-module{
    margin-bottom:32px;
    .v-module-title{
      line-height: 22px;
      font-size:16px;
      margin-bottom:24px;
    }
  }
  .v-intro{
    font-size:16px;
    color:$color-black-65;
    max-width:700px;
    p{
      margin-bottom:24px;
    }
  }
  .v-company-mess{
    margin-top:12px;
    >div{
      margin-right:24px;
    }
  }
}
</style>
